import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { base_url } from "../../utils/axiosConfig";

const Repayment = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id) {
      toast.error("Invalid or missing user information");
      setTimeout(() => navigate("/"), 2000);
      return;
    }

    const initiatePayment = async () => {
      try {
        setLoading(true);

        // 1. Call your backend to create order
        const response = await axios.post(
          `${base_url}cashfree/create-order-repayment`,
          { id },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const { paymentSessionId } = response.data;

        if (!paymentSessionId) {
          throw new Error("No payment session received from server");
        }

        // 3. Start Cashfree checkout
        const cashfree = new window.Cashfree();

        cashfree
          .checkout({
            paymentSessionId,
            redirectTarget: "_self",
            mode: "production", // change to "sandbox" during testing
          })
          .catch((err) => {
            console.error("Cashfree checkout failed:", err);
            toast.error("Failed to open payment gateway. Please try again.");
            setTimeout(() => navigate("/"), 2500);
          });

      } catch (error) {
        console.error("Payment initiation error:", error);

        let errorMessage = "Something went wrong. Please try again.";

        if (error.response) {
          // Server responded with error (4xx, 5xx)
          errorMessage =
            error.response.data?.message ||
            error.response.data?.error ||
            `Server error (${error.response.status})`;
        } else if (error.request) {
          // No response received (network issue)
          errorMessage = "Network error. Please check your internet connection.";
        } else {
          // Other errors (e.g. invalid JSON, etc.)
          errorMessage = error.message || "Unknown error occurred";
        }

        toast.error(errorMessage, {
          position: "top-center",
          autoClose: 5000,
        });

      } finally {
        setLoading(false);
      }
    };

    initiatePayment();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, navigate]);

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.3rem",
          color: "#333",
        }}
      >
        <div>Preparing payment gateway... Please wait</div>
      </div>
    );
  }

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div
        style={{
          height: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.2rem",
          color: "#555",
        }}
      >
        Redirecting to payment page...
      </div>
    </>
  );
};

export default Repayment;